import { Link, useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'
import AuthShell, { Field, SubmitButton } from '@/components/AuthShell'
import { t } from '@/lib/i18n'

export default function ForgotPassword() {
  const form = useForm({ email_address: '' })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post('/passwords')
  }

  return (
    <AuthShell
      title={t('auth.forgot_password.title')}
      subtitle={t('auth.forgot_password.subtitle')}
      footer={
        <>
          {t('auth.forgot_password.remembered')}<Link href="/session/new" className="text-brand font-semibold">{t('auth.forgot_password.back')}</Link>
        </>
      }
    >
      <form onSubmit={submit} className="grid gap-4">
        <Field
          label={t('auth.email')}
          type="email"
          autoComplete="username"
          autoFocus
          required
          value={form.data.email_address}
          error={form.errors.email_address}
          onChange={(e) => form.setData('email_address', e.target.value)}
        />
        <SubmitButton disabled={form.processing}>{form.processing ? t('auth.forgot_password.submitting') : t('auth.forgot_password.submit')}</SubmitButton>
      </form>
    </AuthShell>
  )
}
